import { useQuery } from '@tanstack/react-query';
import { fetchPackageDropApi } from 'apis/package/packageApis';
import { IDropListProps } from 'utils/types/common';

function useClientStatusQuery() {
  const { status, data, error, isFetching } = useQuery(
    ['statusDropList'],
    async () => await fetchPackageDropApi.status(),
    {
      select: (data) => {
        const newArr: IDropListProps[] = [];

        data.map((v, i) =>
          newArr.push({
            key: i,
            value: v.code,
            text: v.code_name,
          }),
        );
        return newArr;
      },
    },
  );
  return { status, data, error, isFetching };
}
export default useClientStatusQuery;
